import { Dialog, DialogContent, DialogTitle, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import DirectReferralForm from './DirectReferralForm';

interface Props {
    open: boolean;
    onClose: () => void;
}

const DirectReferralDialog = (props: Props) => {
    const { open, onClose } = props;
    return (
        <Dialog open={open} onClose={onClose} maxWidth="lg">
            <DialogTitle>
                Direct Referral{' '}
                {onClose ? (
                    <IconButton
                        aria-label="close"
                        onClick={onClose}
                        sx={{
                            position: 'absolute',
                            right: 8,
                            top: 8,
                            color: (theme) => theme.palette.grey[500]
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                ) : null}
            </DialogTitle>
            <DialogContent>
                <DirectReferralForm
                    onSubmitted={() => {
                        onClose();
                    }}
                />
            </DialogContent>
        </Dialog>
    );
};

export default DirectReferralDialog;
